<template>
  <ul class="AirControlWrap">
    <li v-for="(v, i) in tableList" :key="i" class="AirLi">
      <div class="AirControl">
        <div class="titleWrap">
          <el-tag
            size="small"
            style="margin-right: 5px"
            :type="v.active ? '' : 'info'"
            ><p style="font-weight: bold">
              {{ v.Temperature ? v.Temperature.toFixed(1) : "-" }}℃
            </p></el-tag
          >
          <el-tooltip
            class="item"
            effect="dark"
            :content="v.name"
            placement="top-start"
            :disabled="v.name?.length < 18"
          >
            <h6>{{ v.name }}</h6>
          </el-tooltip>
        </div>
        <div class="contentBox">
          <ul class="switchBox">
            <li
              @click="switchBtn(v)"
              :class="{
                disabled: disabled,
              }"
            >
              <i
                class="iconfont icon-zhuxiaoguanji"
                :style="{ color: v.RunSign == 1 ? '#5AD8A6' : '#e84a4a' }"
              ></i>
              <p>{{ v.RunSign == 1 ? "开机" : "关机" }}</p>
            </li>
            <li
              v-for="value in controlMenu"
              :key="value.title"
              :class="{
                activeItem: value.code == v.Status,
                disabled: disabled,
              }"
              @click="changeState(v, value.code)"
            >
              <i :class="value.icon" class="iconfont"></i>
              <p>{{ value.title }}</p>
            </li>
          </ul>
          <div class="temBox">
            <div class="setTemBox">
              <div class="statisContent">
                <ul class="boxItem">
                  <li
                    v-for="(item, index) in v.orderNum"
                    :key="index"
                    :class="{
                      'number-item': !isNaN(item),
                      'mark-item': isNaN(item),
                    }"
                  >
                    <span v-if="!isNaN(item)">
                      <i :ref="'numberItem' + i">0123456789</i>
                    </span>
                    <span class="comma" v-else>{{ item }}</span>
                  </li>
                </ul>
              </div>
              <div class="adjustBtn" v-if="!disabled">
                <i
                  class="iconfont icon-xiangshang"
                  @click="increaseNumber(v, i, 'add')"
                ></i>
                <i
                  class="iconfont icon-xiangxia"
                  @click="increaseNumber(v, i, '')"
                ></i>
              </div>
            </div>
            <div class="setWind">
              <i class="iconfont icon-dafeng"></i>
              <p>风量</p>
              <i
                class="el-icon-minus btn"
                v-if="!disabled"
                @click="changeWind(v, '')"
              ></i>
              <h6>{{ v.SetAirVolume }} <span>%</span></h6>
              <i
                class="el-icon-plus btn"
                v-if="!disabled"
                @click="changeWind(v, 'add')"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
export default {
  props: {
    tableList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      disabled: true,
      controlMenu: [
        { title: "制冷", icon: "icon-zhilengxitongtubiao", code: 0 },
        { title: "制热", icon: "icon-zhire", code: 1 },
        { title: "除湿", icon: "icon-chushi", code: 3 },
        { title: "送风", icon: "icon-songfeng1", code: 2 },
      ],
      timer: null,
      timer1: null,
    };
  },
  watch: {
    tableList: {
      handler(newvalue, oldvalue) {
        this.disabled = !judgeAuthority("zixitong:kongtiao:controls:edit");
        this.getList();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    judgeAuthority,
    switchBtn(item) {
      if (!this.disabled) {
        this.$emit("changeState", {
          entityId: item.id,
          isOpen: item.RunSign == 1 ? "OFF" : "ON",
          key: "RunSign",
        });
        item.RunSign = item.RunSign == 1 ? 0 : 1;
      }
    },
    changeState(item, value) {
      console.log(this.disabled);
      if (!this.disabled) {
        this.$emit("changeState", {
          entityId: item.id,
          isOpen: "CHANGE",
          key: "Status",
          value: value,
        });
      }
    },
    // 设置文字滚动
    setNumberTransform(v, i) {
      let numberItems = this.$refs["numberItem" + i]; // 拿到数字的ref，计算元素数量
      let numberArr = v.orderNum.filter((item) => !isNaN(item));
      // 结合CSS 对数字字符进行滚动,显示数字
      for (let index = 0; index < numberItems.length; index++) {
        let elem = numberItems[index];
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`;
      }
    },
    increaseNumber(item, index, type) {
      let _this = this;
      if (type == "add") {
        if (item.SetTemperature >= 35) {
          this.$message.error("温度设置已达上限!");
          return;
        }
        item.SetTemperature += 1;
      } else {
        if (item.SetTemperature <= 16) {
          this.$message.error("温度设置已达下限!");
          return;
        }
        item.SetTemperature -= 1;
      }
      item.temp = item.SetTemperature + "℃";
      item.orderNum = item.temp.split(""); // 将其便变成数据，渲染至滚动数组
      _this.setNumberTransform(item, index);
      clearTimeout(this.timer);
      this.timer = null;
      this.timer = setTimeout(() => {
        this.$emit("changeState", {
          entityId: item.id,
          isOpen: "CHANGE",
          key: "SetTemperature",
          value: item.SetTemperature,
        });
      }, 2000);
    },

    changeWind(item, type) {
      if (type == "add") {
        if (item.SetAirVolume >= 100) {
          this.$message.error("风量设置已达上限!");
          return;
        }
        item.SetAirVolume += 10;
      } else {
        if (item.SetAirVolume <= 10) {
          this.$message.error("风量设置已达下限!");
          return;
        }
        item.SetAirVolume -= 10;
      }
      clearTimeout(this.timer1);
      this.timer1 = null;
      this.timer1 = setTimeout(() => {
        this.$emit("changeState", {
          entityId: item.id,
          isOpen: "CHANGE",
          key: "SetAirVolume",
          value: item.SetAirVolume,
        });
      }, 2000);
    },
    getList() {
      this.tableList.map((v, i) => {
        this.$nextTick(() => {
          this.setNumberTransform(v, i);
        });
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.AirControlWrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  .AirLi {
    width: 32%;
    height: 250px;
    margin: 0 1% 10px 0;
    display: inline-block;
    .AirControl {
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 10px;
      .titleWrap {
        width: 98%;
        margin: 0 auto;
        height: 40px;
        // background: salmon;
        @include setFlexCenter;
        h6 {
          color: #333;
          font-size: 16px;
          max-width: 80%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .contentBox {
        height: calc(100% - 45px);
        color: #fff;
        @include setFlexAround;
        .switchBox {
          width: 30%;
          height: 100%;
          @include setFlexColumn;
          align-items: center;
          justify-content: space-around;
          li {
            width: 85%;
            height: 16%;
            background: #f7f7f7;
            border-radius: 5px;
            @include setFlexCenter;
            color: #333;
            cursor: pointer;
            i {
              font-size: 22px;
              margin-right: 15px;
            }
          }
          li:not(:first-child):hover {
            background: #53d6d5;
            color: #fff;
          }
          .activeItem {
            color: #fff;
            background: #28cccb !important;
          }
          .disabled {
            color: #c8c8c8 !important;
            &:hover {
              background: #f7f7f7 !important;
              cursor: not-allowed;
            }
          }
        }
        .temBox {
          width: 65%;
          height: 100%;
          .setTemBox {
            width: 95%;
            height: 70%;
            margin: 0 auto;
            @include setFlexAround;
            .statisContent {
              width: 75%;
              height: 100%;
              @include setFlexCenter;
              .boxItem {
                width: 100%;
                .number-item {
                  width: 39%;
                  height: 120px;
                  list-style: none;
                  margin-right: 5px;
                  display: inline-block;
                  font-size: 110px;
                  // font-size: 95%;
                  color: rgba(0, 0, 0, 0.7);
                  & > span {
                    position: relative;
                    display: inline-block;
                    margin-right: 10px;
                    width: 100%;
                    height: 100%;
                    writing-mode: vertical-rl;
                    text-orientation: upright;
                    overflow: hidden;
                    & > i {
                      font-style: normal;
                      position: absolute;
                      top: 7px;
                      left: 50%;
                      transform: translate(-50%, 0);
                      transition: transform 1s ease-in-out;
                      letter-spacing: 10px;
                    }
                  }
                }
                .number-item:last-child {
                  margin-right: 0;
                }
              }
              .mark-item {
                display: inline-block;
                .comma {
                  display: inline-block;
                  color: #999;
                  font-size: 24px;
                }
              }
            }
            .adjustBtn {
              width: 20%;
              height: 70%;
              @include setFlexColumn;
              justify-content: space-around;
              align-items: center;
              i {
                font-size: 30px;
                cursor: pointer;
                color: #333;
              }
              i:hover {
                color: #28cccb;
              }
            }
          }
          .setWind {
            width: 95%;
            height: 20%;
            margin: 5% auto 0;
            background: #f7f7f7;
            color: #333;
            @include setFlexAround;
            i {
              font-size: 22px;
            }
            h6 {
              span {
                font-size: 12px;
                color: #999;
              }
            }
            .btn {
              font-weight: bold;
              cursor: pointer;
              &:hover {
                color: #28cccb;
              }
            }
          }
        }
      }
    }
  }
}
</style>
